// A list of images
export const dataSlideshow = [
  "assets/slideshow/webp/husky_utm_2020.webp",

    "assets/slideshow/webp/ball_catching_ke.webp",
    //"assets/slideshow/robot-lifting-cup.gif",
  //"assets/slideshow/robot-lifting-fabric.gif",
  "assets/slideshow/webp/students_robot.webp",
  "assets/slideshow/webp/arm_farm.webp",  
  "assets/slideshow/webp/utah_flying_1.webp",
  "assets/slideshow/webp/boat_1.webp",
  //"assets/slideshow/boat_2.jpg",
  "assets/slideshow/webp/visual_search_diver_tracking_iros_2020.webp",
  "assets/slideshow/webp/maritime_robotics_2.webp",
  "assets/slideshow/webp/robot-items.webp",   
]
